import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

// Modules
import account from './modules/account';
import auth from './modules/auth';
import common from './modules/common';
import settingsAccount from './modules/settingsAccount';
import settingsCompany from './modules/settingsCompany';
import settingsAuthority from './modules/settingsAuthority';
import settingsMainInfo from './modules/settingsMainInfo';
import media from './modules/media';
import contract from './modules/contract';
import store from './modules/store';
import order from './modules/order';
import advertiser from './modules/advertiser';
import modusign from './modules/modusign';
import rmsDamdang from './modules/rms-damdang'
import board from './modules/board'


const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    account,
    auth,
    common,
    settingsAccount,
    settingsCompany,
    settingsAuthority,
    settingsMainInfo,
    media,
    contract,
    store,
    order,
    advertiser,
    modusign,
    rmsDamdang,
    board
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? [createLogger()] : [],
});
